import { axiosBasic } from "../config/axios-common";


const getParameter = (key: string) => {
    return axiosBasic.get(`/sam/v1/parameter/getParameter?key=${key}`).then(response => {
        return response.data
    })
      .catch(e => {
         console.log(e)
      })
}

const exportedObject = {
    getParameter,
};
  
  
export default exportedObject
  